import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './ui/layout/Layout';
import Page404 from './ui/screens/Page404';
import SignIn from './ui/screens/SignIn';
import { defaultTheme } from './ui/styles/defaultTheme';
import { useEffect } from 'react';
import { useAuthCore } from './core/modules/auth';
import { useMeCore } from './core/modules/me';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { GoogleOAuthProvider } from '@react-oauth/google';
import SignUp from './ui/screens/SignUp';
import Terms from './ui/screens/Terms';
import NotificationListener from './ui/listeners/NotificationListener';
import { Mixpanel } from './MixPanel';
import { PhotoProvider } from 'react-photo-view';
import AppErrorBoundary from './ui/components/AppErrorBoundary';

function App() {
  const { token } = useAuthCore();
  const { getMeUser } = useMeCore();

  useEffect(() => {
    if (token) {
      getMeUser(({ user }) => {
        if (process.env.REACT_APP_MIXPANEL_TOKEN) {
          Mixpanel.people.set({
            $first_name: user.name,
            $email: user.googleEmail,
          });
        }
      });
    }
  }, [token, getMeUser]);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
      <CacheProvider
        value={createCache({
          key: 'muiltr',
          prepend: true,
          stylisPlugins: [],
          insertionPoint: document.getElementById('emotion-insertion-point')!,
        })}
      >
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={defaultTheme}>
            <AppErrorBoundary>
            <PhotoProvider>
              <BrowserRouter>
                <NotificationListener />
                <Routes>
                  <Route index element={<SignIn />} />
                  <Route path="/sign-in" element={<SignIn />} />
                  <Route path="/sign-up" element={<SignUp />} />
                  <Route path="/terminos" element={<Terms />} />
                  <Route path="/dashboard/*" element={<Layout />} />
                  <Route path="*" element={<Page404 />} />
                </Routes>
              </BrowserRouter>
            </PhotoProvider>
            </AppErrorBoundary>
          </ThemeProvider>
        </StyledEngineProvider>
      </CacheProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
